import React from "react";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import AnimatedModal from "./ui/AnimatedModal";
import { Button } from "./ui";

const DocumentSigningConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Document Signing Required",
  message = "This document requires your signature. Would you like to sign it now?",
  isLoading = false,
}) => {
  return (
    <AnimatedModal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdrop
      zIndex="z-[9999]"
      contentClassName="bg-white overflow-hidden shadow-xl border border-gray-100 max-w-lg w-full"
    >
      <div className="px-4 pt-5 pb-4 sm:p-6">
        <div className="sm:flex sm:items-start">
          <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 sm:mx-0 sm:h-10 sm:w-10">
            <DocumentTextIcon className="h-6 w-6 text-primary" />
          </div>
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left flex-1">
            <h3 className="text-lg font-medium text-gray-900">{title}</h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">{message}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse sm:gap-3">
        <Button
          type="button"
          variant="primary"
          size="default"
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          {isLoading ? "Processing..." : "Yes, Sign Now"}
        </Button>
        <Button
          type="button"
          variant="outline"
          size="default"
          onClick={onClose}
          disabled={isLoading}
        >
          No, Skip for Now
        </Button>
      </div>
    </AnimatedModal>
  );
};

export default DocumentSigningConfirmationModal;
